import React, { useContext, useState } from 'react';
import store from '../../store';
import { updatePassword } from '../../constants';
// Custom Components
import ModalFooter from '../ModalFooter';
// Material components
import {
    TextField,
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

export default function ChangePassword() {
    // const classes = useStyles();
    const { reducers, modals } = useContext(store);
    const [password, setPassword] = useState('');

    const handleOpen = () => {
        reducers.handleModals('changePassword', modals.changePassword ? false : true)
    };

    const handleformData = (value) => {
        setPassword(value);
    }

    const handleSubmit = () => {
        if (password !== '') {
            updatePassword(password)
                .then((res) => window.alert(res))
                .catch((err) => window.alert(err))
        }
    }

    return (
        <Dialog open={modals.changePassword} onClose={handleOpen} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Change password</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="password"
                    label="password"
                    type="password"
                    fullWidth
                    value={password}
                    onChange={(e) => handleformData(e.target.value)} />
            </DialogContent>
            <ModalFooter
                handleSubmit={handleSubmit}
                handleOpen={handleOpen} />
        </Dialog>
    );
}